import { erpTranslationsQuery } from "src/system/erpTranslationsQuery.ts";

export const moduleTranslationsQuery = ({ resource }: { resource: string }) =>
  erpTranslationsQuery({
    resource,
    type: "layout",
  });
